import { Box, Container, useTheme } from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import FullScreenDialog from "../FullScreenDialog";
import AddWorkoutProfile from "./AddWorkoutProfile/AddWorkoutProfile";
import useWorkoutProfiles from "./useWorkoutProfiles";
import { t } from "@lingui/macro";
import { GlobalHeader, postClose, PullToRefresh, WarmingUp } from "@WahooFitness/wahoo-offline-mfe";
import { useSearchParams } from "react-router-dom";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import {
  MenuList,
  WfIconContentAddRegular,
  WfIconNavigationCloseRegular,
} from "@WahooFitness/redesignr";

const WorkoutProfiles = ({ openAsDrawer }: { openAsDrawer?: boolean }) => {
  const { palette } = useTheme();
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = useCallback(() => setOpen(true), []);
  const [searchParams, _] = useSearchParams();
  const familyFilter = useMemo(
    () =>
      searchParams.get("familyFilter")
        ? (Number(searchParams.get("familyFilter")) as WahooWorkoutTypeFamily)
        : undefined,
    [searchParams]
  );
  const { workoutProfilesList, workoutProfilesLoading, mutateWorkoutProfiles } = useWorkoutProfiles(
    { familyFilter }
  );

  const closeDrawer = useCallback(() => postClose("workoutProfiles"), []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  if (workoutProfilesLoading) {
    return (
      <React.Fragment>
        <Box>
          <WarmingUp />
        </Box>
      </React.Fragment>
    );
  }

  return (
    <>
      <PullToRefresh onRefresh={mutateWorkoutProfiles} />
      <GlobalHeader
        title={t`Workout profiles`}
        primaryRightActionItem={{ icon: <WfIconContentAddRegular />, action: handleOpen }}
        primaryLeftActionItem={
          openAsDrawer
            ? {
                icon: <WfIconNavigationCloseRegular />,
                action: closeDrawer,
              }
            : undefined
        }
      />
      <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
        <Box pb={1} pt={1}>
          <MenuList
            listItems={workoutProfilesList}
            variant="outlined"
            paperProps={{
              elevation: 0,
              sx: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                alignContent: "flex-start",
                gap: 1,
                border: "none",
                background: palette.background.default,
              },
            }}
          />
        </Box>
        <FullScreenDialog
          slideDirection="up"
          open={open}
          handleClose={handleClose}
          headerProps={{
            title: t`Add workout profile`,
            primaryLeftActionItem: {
              icon: <WfIconNavigationCloseRegular />,
              action: handleClose,
            },
          }}
        >
          <AddWorkoutProfile closeParent={handleClose} familyFilter={familyFilter} />
        </FullScreenDialog>
      </Container>
    </>
  );
};

export default WorkoutProfiles;
